import { useMemo } from "react";
import {
  TextField,
  DatagridConfigurable,
  useTheme,
  NumberField,
} from "react-admin";
import DownloadAction from "../../components/tableListActions/DownloadActionNew";
import getFirstAndLastDateOfCurrentMonth from "../../utils/firstLastDate";
import AccountReceivablePcmCardExpandList from "../../components/accountReceivablePcmCards/expand/AccountReceivablePcmCardExpandList";
import accountReceivablePcmCardFilterList from "../../components/accountReceivablePcmCards/filter/accountReceivablePcmCardFilterList";
import MyDatagridBody from "../../components/common/MyDatagridBody";
import AccountReceivablePcmCardFooterList from "../../components/accountReceivablePcmCards/footer/AccountReceivablePcmCardFooterList";
import useCompanyScopedListFilters from "../../hooks/useCompanyScopedListFilters";
import ManualReportList from "../../components/reports/ManualReportList";

const [firstDate, lastDate] = getFirstAndLastDateOfCurrentMonth();

const AccountReceivablePcmCardList = () => {
  const {
    canSeeCompanyColumn,
    currentCompanyFilter,
    filterDefaultValues,
  } =
    useCompanyScopedListFilters({
      start_date: firstDate,
      end_date: lastDate,
    });
  const [theme] = useTheme("light");

  const list = useMemo(
    () => (
      <ManualReportList
        key={currentCompanyFilter.company_id || "no-company"}
        storeKey={false}
        title="mine.list_title.account_receivable_pcm_card"
        empty={false}
        actions={<DownloadAction />}
        filters={accountReceivablePcmCardFilterList}
        filter={currentCompanyFilter}
        sort={{ field: "customers.code", order: "ASC" }}
        filterDefaultValues={filterDefaultValues}
        requiredFilters={["start_date", "end_date"]}
        // queryOptions={{ meta: { sort: ["customers.created_at ASC"] } }} // overide default sort
      >
        <DatagridConfigurable
          body={<MyDatagridBody footer={<AccountReceivablePcmCardFooterList />} />}
          bulkActionButtons={false}
          expand={<AccountReceivablePcmCardExpandList />}
          isRowExpandable={(row) => row.checks}
          sx={{
            "& .RaDatagrid-expandedPanel > td": {
              p: 0,
              bgcolor: theme !== "dark" ? "#E7EBF0" : "grey.800",
            },
          }}
        >
          {canSeeCompanyColumn ? (
            <TextField label="mine.label.depo" source="company_alias" />
          ) : null}
          <TextField source="code" label="mine.label.customer_code" />
          <TextField source="name" label="mine.label.customer_name" />
          <NumberField source="subtotal" />
        </DatagridConfigurable>
      </ManualReportList>
    ),
    [
      theme,
      canSeeCompanyColumn,
      currentCompanyFilter,
      filterDefaultValues,
    ]
  );
  return list;
};

export default AccountReceivablePcmCardList;
